export const cleanedConcat = (...strings: string[]) => {
  return strings.reduce((acc, val) => {
    return `${acc} ${val || ""}`.trim();
  }, "");
};
